/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';

class TextInput extends React.Component {
    static defaultProps = {
        errorMsg: null,
        id: '',
        inputClassName: '',
        labelClassName: '',
        labelText: 'Specify Label Text',
        min: null,
        onChange: null,
        onKeyPress: null,
        placeHolderText: '',
        required: '',
        type: 'text',
        maxLength: null
    }

    constructor(props) {
        super(props);
        this.state = {value: ''};

        this.handleChange = this.handleChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentWillReceiveProps(newProps){
        if (newProps.value){
            this.setState({
                value: newProps.value
            });
        }
    }

    componentDidMount(){
        this.setState({
            value: this.props.value
        });
    }

    handleChange(e) {
        this.setState({value: e.target.value});

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    handleOnBlur(e) {
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    handleKeyPress(e) {
        if (this.props.onKeyPress) {
            this.props.onKeyPress(e);
        }
    }

    render () {
        const {id, labelText, type, placeHolderText, inputClassName, labelClassName, errorMsg, required, min, maxLength} = this.props;
        let renderErrorMsg = () => {
            if (errorMsg != null){
                return <span className="inputfield-err-msg">{errorMsg}</span>;
            } else {
                return null;
            }
        };

        let renderLabelMsg = () => {
            if (labelText != null || labelText.trim() !== ''){
                return <label className={(errorMsg) != null ? ` showLabelError pe-textLabelInput__label ${labelClassName} ` : `pe-textLabelInput__label  ${labelClassName}`}>{labelText}</label>;
            } else {
                return null;
            }
        };
        return (
            <div>
                {renderLabelMsg()}
                <input
                    id={id}
                    type={type}
                    placeholder = {placeHolderText}
                    className={(errorMsg) != null ? `showInputError pe-textInput--basic ${inputClassName}` : `pe-textInput--basic ${inputClassName}`}
                    value={this.state.value}
                    onChange={this.handleChange}
                    onBlur = {this.handleOnBlur}
                    onKeyPress = {this.handleKeyPress}
                    required={required}
                    min={min}
                    maxLength={maxLength}
                />
                {renderErrorMsg()}
            </div>

        );
    }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/widgets/TextInput/TextInput.js